(window.webpackJsonp=window.webpackJsonp||[]).push([[54],{893:function(e){e.exports=JSON.parse('{"slidesPerView":"auto"}')}}]);